/** @format */

import React from "react";

const Button = ({ btnText, color, bg, btnBlock, children, onClick, ...rest }) => {
  const BUTTON_STYLE = ["btn__block"];
  return (
    <button
      {...rest}
      onClick = {onClick}
      style={{ color: color, backgroundColor: bg }}
      className={`btn ${btnBlock && BUTTON_STYLE[0]}`}
    >
      {children}
      {btnText}
    </button>
  );
};

export default Button;
